import React, { useEffect, useState } from 'react';
import { database } from '../../../utils/firebase';
import './c-component.scss'

const timeFormat  = (sec) => {
    let date = new Date(sec)
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0'+minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
}


const CommentsComponent = ({ eventId , name }) => {
    const [comments, setComments] = useState([])

    useEffect(() => {
        const commentRef = database.ref('Events').child(eventId).child('Comments')
            commentRef.on('value', (el) => {
            let commentData = []
            for (let id in el.val()) {
                commentData.unshift({id, ...el.val()[id]})
            }
            setComments(commentData)
        })
    }, [eventId])

    

    const handleCloseCommentView = () => {
        document.querySelector(`.${eventId}`).classList.add('hide')
        document.querySelector('.admin-background').classList.add('hide')
    }

    const handleCommentDelete = (id) => {
        const commentRef = database.ref('Events').child(eventId).child('Comments').child(id)
        commentRef.remove()
    }   

    return (
        <div className={`edit-comments ${eventId} hide`}>
            <h3>User Comments</h3>
            <p className='event-name-comment'>Comments for - {name}</p>
            <div className="edit-comment-close" onClick={handleCloseCommentView}>
                <i class="fas fa-times"></i>
            </div>



            <div className="comments-container">

                {comments.map(el => {
                    return (
                        <div className='comment'>
                            <div className="delete-comment" onClick={() => handleCommentDelete(el.id)}>
                                <i class="fas fa-times"></i>
                            </div>
                            <div className='c-details'>
                                <div className="top">
                                    <p className='displayed-username'>{el.username}</p>
                                    <p className='displayed-time'>{timeFormat(el.createdAtDate)}</p>
                                </div> 
                                <p className='displayed-comment'>{el.comment}</p>
                                <div className="line"></div>
                            </div>
                        </div>
                    )
                })}
                

                
            </div>

        </div>
    )
}

export default CommentsComponent